import React from "react";
import { useContext } from "react";
import {ReactEvent} from "@mathbuddy/adaptive-practice-events";
import { renderedContext } from "../context/context";
import { isMobileDevice, isTV } from "./Render";
import { IConfig } from "./Render";

export const Div = ({ className, id, children, draggable, style, extraProps }:IConfig) => {

    // Shown, not played (the quiz builder's cards and its preview): every event this part can raise
    // goes through handleEvent, so one guard here is the whole of it. The engine's component object
    // is shared with the screen that opened the preview - an answer given here would follow the
    // question back to it.
    const state: any = useContext(renderedContext);
    // Nothing is dragged either: the handlers below refuse, but a draggable element still lifts off
    // the page under the cursor as though something were happening.
    if (state?.readOnly === true) draggable = false;

    const handleEvent=(type:string, event:any)=>{
        if (state?.readOnly === true) return;
        // The student has done something to this question - see markTouched in PlayFrame.
        state?.markTouched?.();
        const reactEvent = new ReactEvent({id, draggable, extraProps});
        if (extraProps!==null && extraProps!==undefined)
            reactEvent.handleEvent(extraProps.event[type], event);
    }

    let isTv =isTV();
    let isMobile =isMobileDevice();

    return ( <div id = {id}
        className = { className }
        style = { style }
        draggable = { draggable && !isTv }
        onClick = {extraProps && extraProps.isClickable ? (e) => handleEvent("remove",e): undefined}

        onDragStart = {!isMobile && !isTv ?(e) =>handleEvent("dragStart",e):undefined}
        onDrop =      {!isMobile && !isTv && extraProps ?(e) =>handleEvent("drop",e) : undefined }
        onDragOver =  {(!isMobile && !isTv && extraProps && extraProps.dragOver) ? (e) =>handleEvent("dragOver",e) : undefined} 

        onMouseDown = {(isTv &&  draggable) ? (e) => handleEvent("mouseDown",e):undefined}
        onMouseOver = {(isTv && extraProps && extraProps.dragOver)  ? (e) => handleEvent("mouseOver",e) : undefined }

        onTouchStart = {draggable ? (e) => handleEvent("touchStart",e):undefined}
        onTouchMove =  {draggable? (e) => handleEvent("touchMove",e): undefined} 
        onTouchEnd =   {draggable ? (e) => handleEvent("touchEnd",e) : undefined }

        >{ children }</div>
    );
}